import { GridApi } from '@ag-grid-community/core'
import { heliosSizingAdjustments } from './extend-grid-options'

/**
 * Apply data density adjustments to the grid
 */
export function enableHeliosGridDensityLevel(api: GridApi, isDense: boolean) {
  const multiplier = isDense ? 0.75 : 1

  api.setGetRowHeight(params => {
    const isDetailRow = params.node.detail

    if (isDetailRow) {
      return undefined as unknown as number
    }

    return heliosSizingAdjustments.rowHeight * multiplier
  })
  api.setHeaderHeight(heliosSizingAdjustments.headerHeight * multiplier)
  api.resetRowHeights()
  api.forEachNode(node =>
    node.setRowHeight(heliosSizingAdjustments.rowHeight * multiplier),
  )
  api.onRowHeightChanged()
}
/**
 * Apply data density adjustments to the grid with details
 */
export function enableHeliosGridDensityLevelWithDetails(
  api: GridApi,
  isDense: boolean,
  detailRowNumber: number,
  miscAdjuster: number,
) {
  const multiplier = isDense ? 0.75 : 1

  api.setGetRowHeight(params => {
    const isDetailRow = params.node.detail

    if (isDetailRow) {
      return (
        (detailRowNumber * heliosSizingAdjustments.rowHeight +
          heliosSizingAdjustments.headerHeight +
          miscAdjuster) *
        multiplier
      )
    }

    return heliosSizingAdjustments.rowHeight * multiplier
  })
  api.setHeaderHeight(heliosSizingAdjustments.headerHeight * multiplier)
  api.resetRowHeights()
  api.onRowHeightChanged()
}
